'use strict';

var _ = require('lodash');

/**
 * Segmented radio button directive.
 *
 * @example
 * In template:
 * <rm-segmented-radio-button
 *      input-name="market-significance"
 *      items="itemsArray"
 *      ng-model="selectedButton">
 * </rm-segmented-button>
 *
 * In controller:
 *
 * $scope. itemsArray = [
 *      {label: 'Significant', value: 'true' },
 *      {label: 'Maybe', value: 'maybe', disabled: true }
 *      {label: 'Insignificant', value: 'false'}
 * ];
 * $scope. selectedButton = ‘true’;
 *
 * Field ‘value’ in itemsArrays and selectedButton must be a string.
 *
 * To do something when button is clicked you have to watch for changes on selectedButton
 *
 * $scope.$watch(‘selectedButton’, function(...){
 * …
 * });
 * @constructor
 */
var SegmentedRadioButtonDirective = function SegmentedRadioButtonDirective(featureToggleService) {
  return {
    restrict: 'E',
    template: require('../templates/segmented-radio-button.html'),
    replace: true,
    require: 'ngModel',
    /**
     * Directive's scope
     * @param {Object} scope
     * @param {Array} scope.items - Array containing config object for input fields.
     * @param {String} scope.items[].label - Input's Label (displayed to user)
     * @param {String} scope.items[].value - Input's value
     * @param {Boolean} scope.items[].disabled - If true button is disabled
     * @param {Boolean} scope.items[].hideButton - If true button is hidden (for complex cases)
     * @param {String} scope.inputName - Name param for input fields
     * @param {String} scope.className - Class name for buttons. By default btn-default
     */
    scope: {
      items: '=',
      logMetrics: '=',
      inputName: '@',
      className: '@',
      triggerCallBack: '&'
    },
    link: function link(scope, elem, attr, ngModelCtrl) {
      if (!_.isUndefined(scope.items)) {
        scope.buttons = _.cloneDeep(scope.items);
      }
      if (_.isUndefined(scope.className)) {
        scope.className = 'btn-default';
      }
      function findIndexByValue(value) {
        return _.findIndex(scope.buttons, {
          value: value
        });
      }
      function setActive(index) {
        _.each(scope.buttons, function (item) {
          item.active = false;
        });
        if (index > -1) {
          scope.buttons[index].active = true;
        }
      }
      function logMetrics(value) {
        if (scope.logMetrics) {
          scope.$root.$broadcast('workflow-tab-changed', _.kebabCase(value));
        }
      }
      scope.$watch('items', function (newItems, oldItems) {
        if (newItems !== oldItems) {
          var activeButton = _.find(scope.buttons, {
            active: true
          });
          scope.buttons = _.cloneDeep(newItems);
          if (activeButton) {
            setActive(findIndexByValue(activeButton.value));
          }
        }
      }, true);
      scope.showIfFeature = function (item) {
        if (!item.feature) {
          return true;
        }
        return featureToggleService.isEnabled(item.feature);
      };
      elem.on('click', 'button', function () {
        var itemValue = this.querySelector('input').value;
        if (_.isFunction(scope.triggerCallBack)) {
          var returnVal = scope.triggerCallBack();
          if (!_.isUndefined(returnVal) && returnVal === false) {
            return false;
          }
        }
        setActive(findIndexByValue(itemValue));
        scope.$apply(function () {
          ngModelCtrl.$setViewValue(itemValue);
          logMetrics(itemValue);
        });
      });
      ngModelCtrl.$render = function () {
        var value = ngModelCtrl.$viewValue;
        if (!_.isUndefined(value)) {
          setActive(findIndexByValue(value));
          logMetrics(value);
        }
      };
    }
  };
};
SegmentedRadioButtonDirective.$inject = ['FeatureToggleService'];
module.exports = SegmentedRadioButtonDirective;